import React from "react";
import "./footer.css";

function Footer() {
  return (
    <footer id="footer">
      <div className="footer-content">
        <div className="footer-left">
          <h3 className="footer-name">Sean Brill</h3>
          <p className="footer-tagline">Building performant, scalable solutions to empower modern businesses.</p>
        </div>

        <div className="footer-right">
          <div className="footer-col">
            <h4 className="footer-col-title">Contact</h4>
            <a href="mailto:seanbrill54@gmail.com" className="footer-link">seanbrill54@gmail.com</a>
            <a href="tel:215-275-8617" className="footer-link">(215) 275-8617</a>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Socials</h4>
            <a href="https://linkedin.com/in/sean-brill" target="_blank" rel="noreferrer" className="footer-link">LinkedIn</a>
            <a href="https://github.com/seanbrill" target="_blank" rel="noreferrer" className="footer-link">GitHub</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="copyright">© {new Date().getFullYear()} Sean Brill. All rights reserved.</p>
        <p className="thanks">Thanks for checking out my portfolio site 👋🏼</p>
      </div>
    </footer>
  );
}

export default Footer;
